export default "__VITE_ASSET__44407fdc__"